<div
  draggable="true"
  [class.drag-card]="content.id === draggedCard?.id"
  [class.highlight]="content.id === targetCardId"
  (dragstart)="onDragStart(content)"
  (dragover)="onDragOver($event, content.id)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop(content)"
  (dragend)="onDragEnd()"
  class="asset-media mb-2 p-2 status-border {{
    affectedAssets[content.id]?.status || (affectedAssets[content.id] ? 'UNKNOWN' : 'NOT_AFFECTED')
  }}"
  [ngClass]="{
    'pointer-event-none': !isEditing,
    'hidden-asset': content.hidden,
    '': selectedAssetTypes.indexOf(content.id) > -1,
    'as-selector': asSelector,
    'already-selected':
      asSelector && !(!affectedAssets[content.id] || selectedAssetTypes.indexOf(content.id) > -1) && !readOnly,
  }"
  style="min-height: 196px; height: 100%; position: relative"
  [ngStyle]="{ 'background-color': content.initial === false ? '#E2F0F9' : '#ECEEF4' }">
  <!-- Centered eye icon for hidden assets -->
  @if (content.hidden) {
    <div class="centered-eye-icon">
      <img ngSrc=".../../../../../assets/img/project-v2/hide.svg" alt="Hidden asset icon" width="24" height="24" />
    </div>
  }

  @if (
    (!readOnly && asSelector && (!affectedAssets[content.id] || selectedAssetTypes.indexOf(content.id) > -1)) || true
  ) {
    <div class="radio-button-selector d-flex" style="justify-content: space-between">
      <div class="d-flex">
        @if (!readOnly && !isProjectSetting) {
          <label [ngClass]="{ disabled: isBusy }" class="mtm-checkbox mtm-checkbox-green m-0">
            <input
              [disabled]="isBusy || content.hidden"
              [checked]="selectedAssetTypes.indexOf(content.id) > -1"
              (click)="selectAsset($event, content)"
              (keydown.enter)="selectAsset($event, content)"
              name="selectedAssetTypes"
              class="form-check-input"
              type="checkbox" />
            <img
              [ngSrc]="
                selectedAssetTypes.indexOf(content.id) > -1 ? 'assets/svg/selected.svg' : 'assets/svg/unselect.svg'
              "
              alt="checkbox"
              width="20"
              height="20"
              style="cursor: pointer; background-color: transparent !important"
              [style.opacity]="isBusy || content.hidden ? '0.5' : '1'"
              class="checkmark" />
          </label>
        }
        @if (isProjectSetting) {
          <div class="toggle-switch">
            <input
              [id]="content.id"
              [checked]="selectedAssetTypes.includes(content.id)"
              [disabled]="affectedAssets[content.id] && affectedAssets[content.id].projectId !== project?.id"
              (click)="selecteAsset(content.id)"
              (keydown.enter)="selecteAsset(content.id)"
              type="checkbox"
              class="toggle-input" />
            <label
              [for]="content.id"
              class="toggle-label"
              [attr.aria-label]="`Toggle ${content.detail || content.title}`"></label>
          </div>
        }
        <span class="mb-2 _700 ms-2">{{ content.detail || content.title }}</span>
      </div>

      <div class="d-flex">
        @if (content.releaseDate) {
          <span class="content-info _700 f-10 release-date">
            <img
              ngSrc=".../../../../../assets/img/project-v2/watch-icon.svg"
              alt="Release date icon"
              width="16"
              height="16"
              style="margin-right: 6px" />
            {{ formatNgbDate(convertToDateObject(content?.releaseDate)) }}
          </span>
        }
        <div class="align-item-center">
          <mtm-asset-dropdown-menu
            [content]="content"
            [funnel]="funnel"
            [affectedAssets]="affectedAssets"
            [bundle]="bundle"
            [isCreator]="isCreator"
            (openEditAssetModal)="openEditAssetModal($event)"
            (duplicateAsset)="duplicateAsset($event)"
            (hideAsset)="hideAsset($event)"
            (deleteAsset)="deleteAsset($event)"
            (moveToModalOpen)="onMoveToModalOpen($event)">
          </mtm-asset-dropdown-menu>
        </div>
      </div>
    </div>
  }

  <div class="asset-content-header d-flex mb-2 row m-0">
    <div class="d-flex flex-column align-items-start">
      @if (content.releaseDate) {
        <span class="mb-2 content-info-mobile _700 f-10">
          <img
            ngSrc=".../../../../../assets/img/project-v2/watch-icon.svg"
            alt="Release date icon"
            width="16"
            height="16"
            style="margin-right: 6px" />
          {{ formatNgbDate(convertToDateObject(content?.releaseDate)) }}
        </span>
      }
      <div class="d-flex media-items-container">
        @for (media of content.bets; track media) {
          <div class="d-flex align-items-center me-2 content-info">
            <i class="mtm-icon mtm-icon-{{ media?.toLowerCase() }} me-1"></i>
            <span class="text-uppercase _700">{{ media }}</span>
          </div>
        }
      </div>
      <mtm-asset-status-dropdown
        class="mt-1"
        [content]="content"
        [affectedAssets]="affectedAssets"
        [showStatus]="showStatus"
        [projectStatus]="projectStatus"
        [projectColor]="projectColor"
        (statusChange)="changeProjectStatus($event.asset, $event.status)">
      </mtm-asset-status-dropdown>
    </div>

    @for (media of content.bets; track media) {
      <div class="d-flex align-items-center me-2 content-info-mobile col-12 p-0">
        <i class="mtm-icon p-2 mtm-icon-{{ media?.toLowerCase() }} me-1"></i>
        <span class="text-uppercase _700">{{ media }}</span>
      </div>
    }
  </div>

  <div class="asset-content-body d-flex">
    <div class="flex-fill d-flex flex-column mb-1">
      <div class="d-flex flex-md-row flex-column gap-1">
        <div class="d-flex align-items-center mb-1">
          @if (content.length?.[0]) {
            <span>
              <span class="_700">{{ content.length[0].split(' ')[0] }}</span>
              <span>
                {{ content.length[0].substring(content.length[0].split(' ')[0].length) }}
                -
              </span>
            </span>
          } @else {
            <span>N/A -</span>
          }
        </div>
        @if (content.format?.[0]) {
          <div class="d-flex align-items-center mb-1 _700">
            @if (content.format[0].includes(':')) {
              <b>{{ content.format[0].split(':')[0] }}</b
              >:{{ content.format[0].split(':')[1] }}
            } @else {
              {{ content.format[0] }}
            }
          </div>
        }
      </div>
      @if (content.focus || content.type) {
        <div class="d-flex flex-md-row flex-column gap-1">
          @if (content.focus) {
            <div class="d-flex align-items-center mb-1">
              <span class="me-1 text-uppercase">Focus</span>
              <span class="text-ellipsis _700">{{ content.focus }}</span>
            </div>
          }
          @if (content.type) {
            <span class="text-dark">-</span>
            <div class="d-flex align-items-center mb-1">
              <span class="me-1 text-uppercase">Type</span>
              <span class="text-ellipsis _700">{{ content.type }}</span>
            </div>
          }
        </div>
      }
      <div class="d-flex align-item-center mt-2">
        <div class="d-flex align-item-center">
          <img
            ngSrc=".../../../../../assets/img/project-v2/master-icon.svg"
            alt="Master Icon"
            width="13"
            height="13"
            style="margin-right: 6px; margin-top: 3px" />
          <div class="mt-1 _700 f-10 me-2">MASTER</div>
        </div>
        @if (affectedAssets[content.id]) {
          <div
            #drop="ngbDropdown"
            (mouseleave)="out(drop)"
            (mouseenter)="over(drop)"
            class="already-selected-asset-info px-2 py-1 d-flex align-items-center"
            ngbDropdown>
            <i class="mtm-icon mtm-icon-linked-item me-2"></i>
            <span class="text-uppercase">{{
              (projects[affectedAssets[content.id]?.projectId]?.name | slice: 0 : 20) +
                (projects[affectedAssets[content.id]?.projectId]?.name.length > 20 ? '...' : '')
            }}</span>
            <div
              [class.down]="first_awarness_asset === content.id"
              class="project-info-dropdown-menu w-100"
              ngbDropdownMenu>
              <div class="project-logo w-100">
                @if (projects[affectedAssets[content.id]?.projectId]?.avatarUrl) {
                  <img
                    [ngSrc]="`${projects[affectedAssets[content.id]?.projectId]?.avatarUrl}?v=${cacheBuster}`"
                    alt="Project avatar"
                    width="100"
                    height="100"
                    class="h-100 w-100 image-style" />
                }
                @if (!projects[affectedAssets[content.id]?.projectId]?.avatarUrl) {
                  <span
                    [style.backgroundColor]="
                      timelineService.getColorFromName(projects[affectedAssets[content.id]?.projectId]?.name)
                    "
                    class="d-flex align-items-center justify-content-center m-0 c-full-white project-title text-uppercase h-100 w-100">
                    {{ projects[affectedAssets[content.id]?.projectId]?.name | slice: 0 : 2 }}
                  </span>
                }
                @if (projects[affectedAssets[content.id]?.projectId]?.milestoneName) {
                  <div class="milestone-name _700">
                    {{ projects[affectedAssets[content.id]?.projectId]?.milestoneName }}
                  </div>
                }
              </div>
              <div class="project-info d-flex align-items-center justify-content-center p-1">
                <span class="m-0 text-center" style="overflow-wrap: anywhere">
                  {{ projects[affectedAssets[content.id]?.projectId]?.name }}
                </span>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="technical-variants">
        <button
          type="button"
          (click)="content.dropdownOpen = !content.dropdownOpen"
          class="variant-header border-0 bg-transparent w-100 text-start p-0"
          [attr.aria-label]="`Toggle technical variants ${content.dropdownOpen ? 'close' : 'open'}`">
          <span class="dropdown-icon">
            {{ content.dropdownOpen ? '▲' : '▼' }}
          </span>
          <img
            ngSrc=".../../../../../assets/img/project-v2/droup-down-content.svg"
            alt="Dropdown icon"
            width="16"
            height="16" />
          <span class="variant-title">TECHNICAL VARIANTS</span>
          <span class="variant-count">
            {{ content?.subAsset ? content?.subAsset?.length : 0 }}
          </span>
        </button>
        @if (content.dropdownOpen) {
          <div class="asset-list mt-3">
            @for (variant of content?.subAsset; track variant.id || $index) {
              <div
                [ngStyle]="{ 'background-color': content.initial === false ? '#E2F0F9' : '#ECEEF4' }"
                class="asset-card">
                @if (
                  (!readOnly &&
                    asSelector &&
                    (!affectedAssets[content.id] || selectedAssetTypes.indexOf(content.id) > -1)) ||
                  true
                ) {
                  <div class="radio-button-selector d-flex" style="justify-content: space-between">
                    <div class="d-flex">
                      <span class="mb-2 _700 text-uppercase" style="overflow-wrap: anywhere">
                        {{ variant.detail || variant.title }}
                      </span>
                    </div>
                    <div class="d-flex">
                      <div class="align-item-center">
                        <mtm-variant-dropdown-menu
                          [content]="content"
                          [variant]="variant"
                          [funnel]="funnel"
                          (editVariant)="openEditAssetModal($event)"
                          (duplicateVariant)="duplicateVariant($event)"
                          (deleteVariant)="deleteVariant($event)">
                        </mtm-variant-dropdown-menu>
                      </div>
                    </div>
                  </div>
                }

                <div class="asset-content-header d-flex flex-wrap align-items-center justify-content-between mb-2">
                  <div class="d-flex flex-wrap flex-grow-1">
                    @for (media of variant.bets; track media) {
                      <div class="d-flex align-items-center me-2">
                        <i class="mtm-icon mtm-icon-{{ media?.toLowerCase() }} me-1"></i>
                        <span class="text-uppercase _700">{{ media }}</span>
                      </div>
                    }
                  </div>
                  <mtm-variant-status-dropdown
                    [content]="content"
                    [variant]="variant"
                    [variantStatus]="getVariantStatus(affectedAssets[content.id], variant.id)"
                    [showStatus]="showStatus"
                    [projectStatus]="projectStatus"
                    [projectColor]="projectColor"
                    (statusChange)="changeProjectVarientStatus($event.content, $event.variantId, $event.status)">
                  </mtm-variant-status-dropdown>
                </div>
                <div class="d-flex align-items-center mb-1">
                  @if (variant.length?.[0]) {
                    <div>
                      <span class="_700">
                        {{ getLengthLabel(variant.length[0]).split(' ')[0] }}
                      </span>
                      <span>
                        {{
                          getLengthLabel(variant.length[0]).substring(
                            getLengthLabel(variant.length[0]).split(' ')[0].length
                          )
                        }}
                        -
                      </span>
                    </div>
                  } @else {
                    <span>N/A -</span>
                  }
                  @if (variant.format?.[0]) {
                    <div class="d-flex align-items-center ms-1">
                      <span class="me-2 _700 text-uppercase">
                        @if (variant.format[0].includes(':')) {
                          <b>{{ variant.format[0].split(':')[0] }}</b
                          >:{{ variant.format[0].split(':')[1] }}
                        } @else {
                          {{ variant.format[0] }}
                        }
                      </span>
                    </div>
                  }
                  <span class="text-ellipsis"></span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
